<template>
    <div class="m-auto mb-12 mt-12 flex flex-col items-center pb-12">
        <ProgressSpinner
            animationDuration=".5s"
            strokeWidth="1"
            style="width: 4px; height: 50px"
        />
        <slot name="loadingText">
            <div class="text-base text-ds-primary-500">Loading Data</div>
        </slot>
    </div>
</template>

<script lang="ts" setup>
import ProgressSpinner from 'primevue/progressspinner';
</script>
